import React, { useState } from 'react';
import { func, string } from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import classNames from 'classnames';

import { intlShape, injectIntl } from '../../../../util/reactIntl';
import {
  Button,
  Form,
  IconSearch,
  LocationAutocompleteInput,
  NamedLink,
} from '../../../../components';

import css from './CustomSearchForm.module.css';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const identity = v => v;

const LocationSearchField = props => {
  const { intl, handleChange, isLandingLocation, isSearchPageFilter, isLandingPage } = props;
  return (
    <Field
      name="location"
      format={identity}
      render={({ input, meta }) => {
        const { onChange, ...restInput } = input;

        // Merge the standard onChange function with custom behaviur. A better solution would
        // be to use the FormSpy component from Final Form and pass this.onChange to the
        // onChange prop but that breaks due to insufficient subscription handling.
        // See: https://github.com/final-form/react-final-form/issues/159
        const searchOnChange = value => {
          onChange(value);
          handleChange(value);
        };

        const searchInput = { ...restInput, onChange: searchOnChange };
        return (
          <LocationAutocompleteInput
            placeholder={intl.formatMessage({ id: 'LandingSearchForm.placeholder' })}
            iconClassName={css.searchInputIcon}
            inputClassName={css.searchInput}
            predictionsClassName={css.searchPredictions}
            input={searchInput}
            meta={meta}
            rootClassName={isLandingLocation && css.landingLocationSearch}
            isLandingLocation={isLandingLocation}
            isSearchPageFilter={isSearchPageFilter}
          />
        );
      }}
    />
  );
};

const LandingSearchFormComponent = props => {
  const handleChange = location => {
    if (location.selectedPlace) {
      // Note that we use `onSubmit` instead of the conventional
      // `handleSubmit` prop for submitting. We want to autosubmit
      // when a place is selected, and don't require any extra
      // validations for the form.
      props.onSubmit({ location });
    }
  };

  return (
    <FinalForm
      {...props}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          values,
          intl,
          form,
          viewport,
          isSearchPageFilter,
          isLandingPage,
          searchLabel,
        } = formRenderProps;

        const isMobileLayout = viewport && viewport?.width < 550;
        const location = useLocation();
        const search = location?.search;

        const classes = classNames(rootClassName || css.root, className, {
          [css.searchPageFilter]: isSearchPageFilter,
        });

        return (
          <Form className={classes} onSubmit={e => e.preventDefault()}>
            <LocationSearchField
              intl={intl}
              handleChange={location => {
                if (location.selectedPlace) {
                  form.change('location', location);
                }
              }}
              isLandingLocation={true}
              isSearchPageFilter={isSearchPageFilter}
            />
            <div className={css.rightsearch}>
              {search?.length > 1 && !isMobileLayout ? (
                <NamedLink className={css.clearFilter} name="LandingPage">
                  &times;
                </NamedLink>
              ) : null}
              <div className={classNames(isLandingPage ? css.fullWidthBtn : css.footerBtn)}>
                <Button
                  className={css.searchBtn}
                  onClick={() => props.onSubmit(values)}
                  type="submit"
                >
                  <IconSearch />
                </Button>
              </div>
            </div>
          </Form>
        );
      }}
    />
  );
};

LandingSearchFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  searchLabel: 'Search',
};

LandingSearchFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  onSubmit: func.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const LandingSearchForm = injectIntl(LandingSearchFormComponent);

export default LandingSearchForm;
